module.exports = __webpack_public_path__ + "img/ausstellung7.46f20d14.jpg";